import styled from "styled-components";

export const Wrapper = styled.div`
width: 100%;
height: 100%;
display: flex;
position: relative;
top: 60px;
justify-content: center;
align-items: center;`;